'use client';

import { useEffect, useState } from 'react';

export const useCreateElement = (
  tagName: HTMLElementTagNameMap,
  options?: ElementCreationOptions
): HTMLElement | null => {
  const [element, setElement] = useState<HTMLElement | null>( null );

  useEffect( () => {
    const el = document.createElement( tagName, options );

    setElement( el );
  }, [tagName, options] );

  return element;
};
